<!--
Copyright 2025 Carnegie Mellon University. All Rights Reserved.
 Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<app-topbar></app-topbar>
<app-event-template-memberships [eventTemplateId]="eventTemplateId"></app-event-template-memberships>